var _desc, _path, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgModule5Icon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M12,22.6C6.2,22.6,1.4,17.8,1.4,12S6.2,1.4,12,1.4 S22.6,6.2,22.6,12S17.8,22.6,12,22.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3,9.9c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.9,0.7,1.6,1.6,1.6 c0.9,0,1.6-0.7,1.6-1.6c0-0.2,0-0.3-0.1-0.5C13.4,10.2,13.4,10,13.3,9.9L13.3,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3,13.4h-0.8c-0.9,0-1.7,0.4-2.2,1.2C9,15.1,8.9,15.5,8.9,16v1.8h6V16c0-0.5-0.1-1-0.4-1.4C14,13.9,13.2,13.4,12.3,13.4 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.8,
    cy: 8.2,
    rx: 2.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9,16c0-0.7,0.2-1.4,0.6-2c0.4-0.6,1-1.1,1.7-1.4c-0.4-0.4-0.7-0.9-0.8-1.5c-0.4,0.3-0.8,0.5-1.5,0.5 c-0.8,0-1.5-0.3-2.1-0.7c-0.8,0.4-1.4,0.9-1.9,1.7c-0.4,0.7-0.6,1.4-0.6,2.2v2h4.6V16z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 8.2,
    rx: 2.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,12.6c-0.5-0.7-1.1-1.2-1.9-1.6c-0.6,0.4-1.3,0.7-2.1,0.7c-0.6,0-1.1-0.2-1.4-0.6c-0.1,0.6-0.4,1.2-0.8,1.6 c0.7,0.3,1.3,0.8,1.7,1.4c0.4,0.6,0.6,1.3,0.6,2v0.7h4.6v-2C20.5,14,20.3,13.2,19.9,12.6L19.9,12.6z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgModule5Icon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/module5icon.73579dbc.svg";
export { ForwardRef as ReactComponent };